/**
 * Transform token from oauth2
 * @param {Object} tokens
 * @returns {Object}
 */
export const transformTokens = (input = {}) => {
	return {
		accessToken: input.access_token,
		refreshToken: input.refresh_token,
	};
};